type FooterActionProps = {
  title: string;
  buttonText: string;
  onClick: () => void;
};

export default function FooterAction({
  title,
  buttonText,
  onClick,
}: FooterActionProps) {
  return (
    <div className="mt-4 text-center">
      <p className="text-sm text-startfly-gray">
        {title}
        <button
          type="button"
          onClick={onClick}
          className="text-startfly-gold hover:underline font-medium px-1"
        >
          {buttonText}
        </button>
      </p>
    </div>
  );
}
